import React from "react";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import SvgIcon from "../SvgIcon";
class ThumbnailUploadInput extends React.Component {
  constructor(props) {
    super(props);
    const fullImagePath = props.defaultValue.file
      ? `/api/file/${props.defaultValue.file}`
      : props.defaultValue;
    this.state = {
      modified: false,
      src: fullImagePath || {},
      backgroundedit: props.backgroundedit || {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.inputRef = React.createRef();
  }
  handleChange({ target }) {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];
      // setup file reader
      const fileReader = new FileReader();
      // store the image in state once it’s loaded off the file system
      fileReader.onload = (event) => {
        this.setState({
          src: event.target.result,
          modified: true,
          backgroundedit: undefined,
        });
      };
      // handle the error...kind of.
      fileReader.onerror = function (event) {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };
      // finally read the file
      fileReader.readAsDataURL(file);
    }
  }

  /**
   * Reset the input if the thumbnail change
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps) {
    if (prevProps.widgetLinkThumbnail !== this.props.widgetLinkThumbnail) {
      this.setState({
        src: undefined,
        modified: false,
        backgroundedit: {},
      });

      this.inputRef.current.value = "";
    }
  }

  render() {
    const { name, widgetLinkThumbnail } = this.props;
    const { modified, src, backgroundedit } = this.state;
    const defaultValue = this.props.defaultValue.file;
    const imageBackground = backgroundedit
      ? backgroundedit
      : src || defaultValue;
    return (
      <div>
        <label>
          <div
            className={
              !widgetLinkThumbnail &&
              typeof imageBackground === "object" &&
              Object.keys(imageBackground).length === 0
                ? "add-new-image-div"
                : "add-new-image-div cursor-pointer"
            }
            style={
              typeof imageBackground === "object" &&
              Object.keys(imageBackground).length === 0 &&
              widgetLinkThumbnail &&
              widgetLinkThumbnail !== "unavailable"
                ? {
                    position: "relative",
                    cursor: "pointer",
                    backgroundImage: `url(${widgetLinkThumbnail})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                  }
                : {
                    position: "relative",
                  }
            }
          >
            <div style={{ textAlign: "center" }}>
              {/* if there is not image to search */}
              {!widgetLinkThumbnail &&
              typeof imageBackground === "object" &&
              Object.keys(imageBackground).length === 0 ? (
                <div>
                  <span
                    style={{
                      font: "normal normal normal 10px/18px Open Sans",
                      color: "#FFFFFF",
                      opacity: 0.6,
                    }}
                  >
                    Thumbnail will be previewed once you paste the URL Link
                  </span>
                </div>
              ) : // if the website have not an image
              typeof imageBackground === "object" &&
                Object.keys(imageBackground).length === 0 &&
                widgetLinkThumbnail &&
                widgetLinkThumbnail === "unavailable" ? (
                <div>
                  <span
                    style={{
                      font: "normal normal normal 10px/18px Open Sans",
                      color: "#FFFFFF",
                      opacity: 0.6,
                    }}
                  >
                    Thumbnail isn’t available
                  </span>
                  <div
                    style={{ border: "none", cursor: "pointer" }}
                    className="main-edit-image-icon"
                  >
                    <p className="p4">Upload Image</p>
                    <SvgIcon src="/img/new-icons/add-square-outline.svg" />
                  </div>
                </div>
              ) : typeof imageBackground === "object" &&
                Object.keys(imageBackground).length === 0 &&
                widgetLinkThumbnail &&
                widgetLinkThumbnail !== "unavailable" ? (
                <div>
                  <div
                    style={{ border: "none", cursor: "pointer" }}
                    className="main-edit-image-icon"
                  />
                </div>
              ) : (
                <div style={{ height: "100%" }}>
                  <img src={imageBackground} />
                  <div
                    style={{ border: "none", cursor: "pointer" }}
                    className="main-edit-image-icon"
                  />
                </div>
              )}
            </div>
          </div>
          <input
            style={{ display: "none" }}
            key={defaultValue}
            ref={this.inputRef}
            id="file-input"
            className="file-input"
            {...this.props}
            type="file"
            accept="image/*"
            required={!defaultValue && this.props.required}
            onChange={this.handleChange}
            defaultValue={undefined}
          />
        </label>
        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
          />
        )}
      </div>
    );
  }
}
ThumbnailUploadInput.defaultProps = {
  defaultValue: {},
};
ThumbnailUploadInput.contextTypes = { locals: PropTypes.object };

export default ThumbnailUploadInput;
